import { render, staticRenderFns } from "./EducationalGroupUpdate.vue?vue&type=template&id=289488f4&"
import script from "./EducationalGroupUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports